export const defaultFCValue = 0

export const typeOptions = [
  {
    label: 'Todos',
    value: '0',
  },
  {
    label: 'Recebimento',
    value: 'RECEIVEMENT',
  },
  {
    label: 'Dano',
    value: 'DAMAGED',
  },
  {
    label: 'Ajuste',
    value: 'ADJUSTMENT',
  },
  {
    label: 'Checkout',
    value: 'CHECKOUT',
  },
  {
    label: 'Estorno',
    value: 'REFUND',
  },
  {
    label: 'Validade',
    value: 'EXPIRED_DUE_DATE',
  },
]
